<p>component-base-page works!</p>
